import { createSelector } from '@reduxjs/toolkit';
import get from 'lodash/get';

export const getModels = (state) => get(state, 'models.data');

export const makeAtoCompleteOptions = (values = []) =>
  values.reduce((acum, act) => {
    return [
      ...acum,
      {
        label: act,
        value: act,
      },
    ];
  }, []);

export const getModelsOptions = createSelector(
  getModels,
  makeAtoCompleteOptions,
);
